import api from '../../utils/api'

export const state = {}

export const mutations = {}

export const actions = {
  async handleTagsInstructionalVideos(_) {
    try {
      const { data } = await api.get(`/tags/instructional-videos`)
      return data
    } catch (e) {

    }
  }
}

export const getters = {}
